export function createEventBus() {
    const listeners = new Map();

    const on = (event, handler) => {
        const handlers = listeners.get(event) || new Set();
        handlers.add(handler);
        listeners.set(event, handlers);
    };

    const off = (event, handler) => {
        if (!listeners.has(event)) {
            return;
        }
        if (!handler) {
            listeners.delete(event);
            return;
        }
        const handlers = listeners.get(event);
        handlers.delete(handler);
        if (handlers.size === 0) {
            listeners.delete(event);
        }
    };

    const emit = (event, payload) => {
        const handlers = listeners.get(event);
        if (!handlers) {
            return;
        }
        handlers.forEach(handler => handler(payload));
    };

    return {
        $on: on,
        $off: off,
        $emit: emit,
        on,
        off,
        emit
    };
}
